<div class="container-sp main-body full">
    <router-outlet></router-outlet>
</div>
